import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
  toJS,
} from 'mobx'

import {PaymentService as Service} from 'rest/services/PaymentService'
import {Stores} from './index'
import {PaymentMethodDto} from 'rest'
import {PaymentMethodCreateDto} from 'rest/models/PaymentMethodCreateDto'
import {InvoiceDto} from 'rest/models/InvoiceDto'

export class PaymentStore {
  stores: Stores
  _payment: PaymentMethodDto[]
  _invoices: InvoiceDto[]
  swagger_edit_url: string

  constructor(stores: Stores) {
    this.stores = stores
    makeObservable(this, {
      _payment: observable,
      _invoices: observable,
      swagger_edit_url: observable,
      cards: computed,
      // getPayments: action,
      getInvoices: action,
      setDefaultPaymentMethod: action,
    })
  }

  get cards() {
    return toJS(this._payment)
  }

  get invoices() {
    return toJS(this._invoices)
  }

  addPayment = async (body: PaymentMethodCreateDto): Promise<any> => {
    try {
      // await this.getPayments()
      return this._payment
    } catch (err) {
      this.stores.ErrorStore.handle(err)
    }
  }

  deletePayment = async (paymentMethodId: string): Promise<any> => {
    try {
      if (this.cards.length > 1) {
        const res = await Service.deleteApiPaymentDelete(paymentMethodId)
        // await this.getPayments()
        return res
      } else {
        this.stores.ErrorStore.handle(
          new Error('You must keep at least one payment method')
        )
        return false
      }
    } catch (err) {
      this.stores.ErrorStore.handle(err)
    }
  }

  getInvoices = async (): Promise<any> => {
    if (this.stores.MerchantStore.merchant?.merchantId)
      try {
        const res = await Service.getApiPaymentGetInvoices(
          this.stores.MerchantStore.merchant.merchantId
        )
        this._invoices = res.data
      } catch (err) {
        if (err?.body?.message === 'Sequence contains no elements')
          runInAction(() => (this._payment = []))
        this.stores.ErrorStore.handle(err)
      }
  }

  getSwaggerEditURL = async (returnUrl = ''): Promise<any> => {
    if (this.stores.MerchantStore.merchant?.merchantId)
      try {
        const res = await Service.getApiPaymentSession(
          this.stores.MerchantStore.merchant.merchantId,
          returnUrl
        )
        this.swagger_edit_url = res.data
      } catch (err) {
        if (err?.body?.message === 'Sequence contains no elements')
          runInAction(() => (this._payment = []))
        this.stores.ErrorStore.handle(err)
      }
  }

  setDefaultPaymentMethod = async (paymentMethodId: string): Promise<any> => {
    try {
      const res = await Service.postApiPaymentSetDefaultMethod(
        this.stores.MerchantStore.merchant.merchantId,
        paymentMethodId
      )
      // await this.getPayments()
      return res
    } catch (err) {
      this.stores.ErrorStore.handle(err)
      //console.error(err)
      return err
    }
  }
}
